import { InfoOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

const AppVersion = () => {
  const appVersion = import.meta.env.VITE_REACT_APP_VERSION;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <InfoOutlined sx={{ fontSize: 16, color: 'info.dark' }} />
      <Typography
        sx={{ pl: 1, color: 'info.dark' }}
        variant='body2'
      >
        GX Go app version {appVersion}
      </Typography>
    </Box>
  );
};

export default AppVersion;
